import { UserCircleIcon } from '@phosphor-icons/react/dist/ssr/UserCircle';
import { vars } from '@tgtg/kit';
import { useState } from 'react';
import { useIntl } from 'react-intl';

import msg from '../messages';
import UserMenuPopover from '../UserMenuPopover';

import BottomBarButton from './BottomBarIButton';

import type { MouseEvent } from 'react';

const BottomBarUserMenu = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const isPopoverOpen = Boolean(anchorEl);
  const { formatMessage } = useIntl();
  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <BottomBarButton
        icon={
          <UserCircleIcon
            style={{ color: 'inherit', width: vars.size.medium, height: vars.size.medium }}
          />
        }
        label={formatMessage(msg.profile)}
        onClick={handleClick}
        isActive={isPopoverOpen}
      />
      <UserMenuPopover
        anchorEl={anchorEl}
        isPopoverOpen={isPopoverOpen}
        onPopoverClose={handleClose}
      />
    </>
  );
};

export default BottomBarUserMenu;
